import { getEnvVariables } from "lib/environment";

// Endpoint to redirect the user to in order to log them out of any existing Okta sessions
// The fromURI query parameter is used to redirect the user back to the application after they have been logged out of Okta.
const oktaLogoutUrl = (redirectUrl: string) => {
  const oktaOrigin = getEnvVariables().oktaHostUrl;
  const pathname = "/login/signout";
  const search = `?fromURI=${encodeURIComponent(redirectUrl)}`;

  return `${oktaOrigin}${pathname}${search}`;
};

export default oktaLogoutUrl;
